import get from 'lodash/get';

export const processHtml = (htmlString, variables) => {
    return htmlString?.replace(/\{\{(\w+)\}\}/g, (_, key) => variables[key] ?? '???');
  }
export const processHtmlStyles = (htmlString, config) => {
    const html = htmlString?.replace(/<<([^>]+)>>/g, (_, key) => get(config, key, ""));
    return html;
  }